/**
 * Google Tag Manager adapter.
 * window.dataLayer.push 만 담당. 실제 GA4/Ads 등 라우팅은 GTM 워크스페이스가 처리.
 * GTM SDK 로드는 snippets/google-tag-manager.liquid 가 담당.
 *
 * FP-1152: 이 어댑터가 push 하는 이벤트는 GA4 분석용이므로 analytics 카테고리다.
 * 광고 태그의 동의 처리는 Consent Mode(advanced)가 GTM 안에서 담당한다 —
 * 태그별 additional consent check 는 걸지 않는다(명세서 6절).
 */
(function () {
  'use strict';
  if (!window.GBTrack) { console.warn('[GBTrack:gtm] core not loaded'); return; }

  function analyticsAllowed() {
    var c = window.GBConsent;
    return !!(c && c.isAllowed('analytics'));
  }

  // canonical → GA4 권장 이름 (GTM 내부 태그가 GA4로 매핑할 때 표준 사용)
  // 또한 GA4 이벤트명 40자 제한 회피 매핑.
  var NAME_MAP = {
    product_view: 'view_item',
    product_variant_select: 'select_item',
    cart_update: 'cart_update',
    filter_apply: 'filter_apply',
    modal_open: 'modal_open',
    modal_close: 'modal_close',
    cta_click: 'select_content',
    section_view: 'section_view',
    menu_click: 'navigation',
    // GA4 40자 truncation 회피 (원본 41자)
    collection_product_grid_product_impression: 'collection_grid_impression',
    collection_product_grid_product_click: 'collection_grid_click',
  };

  var adapter = {
    name: 'gtm',
    init: function () {
      // GTM 스니펫이 이미 window.dataLayer 를 초기화했지만 안전장치.
      window.dataLayer = window.dataLayer || [];
    },
    isReady: function () { return !!window.dataLayer; },
    transform: function (event, props, context) {
      var gtmEvent = NAME_MAP[event] || event;
      // dataLayer 표준: { event, ...context, ...props }.
      // GA4 e-commerce items/ecommerce 같은 필드는 호출부 overrides.gtm 으로 전달.
      return Object.assign({ event: gtmEvent }, context, props);
    },
    send: function (payload) {
      if (!analyticsAllowed() || !window.dataLayer) return;
      // payload 전체를 그대로 push. (코어가 이미 overrides 를 Object.assign 으로 merge 해둠.)
      window.dataLayer.push(payload);
    },
    isAllowed: function () { return analyticsAllowed(); },
    setUserId: function (id) {
      if (!analyticsAllowed() || !window.dataLayer) return;
      if (id) window.dataLayer.push({ event: 'gb_set_user_id', user_id: String(id) });
      else window.dataLayer.push({ event: 'gb_clear_user_id', user_id: null });
    },
    // 철회 → GTM 측 user_id 도 즉시 해제. Consent Mode update(denied)는 consent-signal 이 별도로 push.
    onConsentRevoked: function (revoked) {
      if (!revoked.analytics || !window.dataLayer) return;
      window.dataLayer.push({ event: 'gb_clear_user_id', user_id: null });
    },
  };

  window.GBTrack.register(adapter);
})();
